import React from 'react'
import { Typography } from '@mui/material'
import { WorkTimeControlIcon } from 'redesign/components/atoms/Icon'
import Switch from 'redesign/components/atoms/Switch'
import IconAndTextBlock from 'redesign/components/molecules/IconAndTextBlock'
import DayPicker from 'redesign/components/organisms/day-picker/day-picker'
import InfoModal from 'redesign/components/organisms/modals/info-modal'
import { Z_INDEX_NESTED_MODAL } from 'redesign/shared/zIndex/constants'
import { SET_VALUE_KEYS } from './constants'
import { useAbsenceDateSelection } from './hooks/use-absence-date-selection'
import { DateFieldsContainer, DateSelectionContainer } from './styles'
import type { AbsenceDateSelectionProps } from './types'

const AbsenceDateSelection: React.FC<AbsenceDateSelectionProps> = (props) => {
  const { showDialogBlockedPeriod, setShowDialogBlockedPeriod } = props
  const {
    t,
    onChange,
    handleAcceptFromDate,
    handleAcceptToDate,
    today,
    fromDate,
    toDate,
    numDays,
    displayNumDays,
    iconColor,
    isSmallScreen,
    infoDialogText,
    fromDateError,
    toDateError,
    maxDate,
    isMultipleDays,
    switchProps,
  } = useAbsenceDateSelection(props)

  return (
    <DateFieldsContainer>
      <Switch {...switchProps} />
      <DateSelectionContainer>
        <DayPicker
          error={fromDateError}
          dataTestId="new-absence-request_date-from"
          label={t('absenceRequest.new.multiFromDate.label')}
          maxDate={maxDate}
          minDate={today}
          onAccept={handleAcceptFromDate}
          onChange={(newValue) => onChange({ newValue, keyValue: SET_VALUE_KEYS.fromDate })}
          value={fromDate}
        />
        {isMultipleDays && (
          <DayPicker
            error={toDateError}
            dataTestId="new-absence-request_date-to"
            label={t('absenceRequest.new.toDate.label')}
            maxDate={maxDate}
            minDate={(fromDate as Date) ?? today}
            onChange={(newValue) => onChange({ newValue, keyValue: SET_VALUE_KEYS.toDate })}
            onAccept={handleAcceptToDate}
            value={toDate}
          />
        )}
      </DateSelectionContainer>
      {displayNumDays && (
        <IconAndTextBlock
          icon={<WorkTimeControlIcon color={iconColor} />}
          variant="body2"
          title={t('absenceRequest.new.numDaysLabelDays', {
            numDays,
          })}
        />
      )}
      <InfoModal
        isOpen={showDialogBlockedPeriod}
        isSmallScreen={isSmallScreen}
        headerLabel={t('label.notice!')}
        onClose={() => setShowDialogBlockedPeriod(false)}
        customZIndex={Z_INDEX_NESTED_MODAL}
      >
        <Typography variant="body2">{infoDialogText}</Typography>
      </InfoModal>
    </DateFieldsContainer>
  )
}

export default AbsenceDateSelection
